import { Component, Vue } from 'vue-property-decorator'
import { queryClassList, classOverAction, queryEvaluationSellOrder, setEvaluationSellOrder } from '@/api'
import HighFilter from '@/components/highFilter/index.vue'
@Component({ name: 'quality_class_list', components: { HighFilter } })
export default class ClassListPage extends Vue {
  private tableData = []
  private totalPage = 1;
  private currentPage = 1;
  private qualityTestingDialog= false
  private teacherChoose = ''
  private classChoose = ''
  private clickType: any = null
  private mentorList = []
  private filterData: any = {};
  private filterResult: any = null
  private showHighFilter = false
  private tableloading: any =false
  private multipleSelection: any = []
  created () {
    this.initPageData()
  }

  get inclass () {
    return this.getinclass()
  }

  getinclass () {
    return this.tableData.filter((item: any) => { return item.status === 2 })
  }

  private async initPageData () {
    const list: any = [{ path: '/class/relation/create/mentor', pathName: 'createMentorRelation' }, { path: '/class/edit/courseCode', pathName: 'editCourseCode' }, { pathName: 'classOverAction', path: '/workOrder/submitter/create/classEnd' }]
    this.tableloading = true
    const param: any = { page: this.currentPage, limit: 20 }
    if (this.filterResult) {
      param.search = this.filterResult
    }
    param.pathList = list
    const result: any = await queryClassList(param)
    this.totalPage = result.allPage
    this.currentPage = result.currentPage
    this.tableData = result.classList
    this.filterData = result.search
    this.tableloading = false
  }

  /**
  * [description] 分页切换回调函数
  */
  private async onPageChange () {
    this.initPageData()
  }

  statusFilter (status: any) {
    const statusStr = ['', '未上课', '上课中', '异常中', '即将结课']
    return statusStr[status]
  }

  async classOverClick (data: any) {
    await classOverAction({ classId: data.classId })
    this.$message({ type: 'success', message: '申请成功' })
    this.initPageData()
  }

  private rowClicked (row: any) {
    this.$router.push({ path: '/student/class_detail', query: { id: row.classId, detailType: '1' } })
  }

  private async setQualityClicked (row: any, type: any) {
    this.clickType = type
    if (type === 2) {
      this.classChoose = row.classId
    }
    const result: any = await queryEvaluationSellOrder({})
    this.mentorList = result
    this.qualityTestingDialog = true
  }

  private async handleSelectionChange (val: any) {
    this.multipleSelection = val
  }

  private async onFilterResult (data: any) {
    this.filterResult = data
    this.currentPage = 1
    await this.initPageData()
    this.showHighFilter = false
  }

  private async onSetClick () {
    if (this.clickType === 1) {
      let list: any = []
      list = this.multipleSelection.map(function (item: any) {
        return item.classId
      })
      const parms = { userId: this.teacherChoose, classId: list }
      const { error }: any = await setEvaluationSellOrder(parms)
      if (!error) {
        this.$message({ type: 'success', message: '设置成功' })
        this.qualityTestingDialog = false
        this.initPageData()
      }
    } else {
      const parms = { userId: this.teacherChoose, classId: [this.classChoose] }
      const { error }: any = await setEvaluationSellOrder(parms)
      if (!error) {
        this.$message({ type: 'success', message: '设置成功' })
        this.qualityTestingDialog = false
        this.initPageData()
      }
    }
  }
}
